export var cibZorin = ["32 32", "<path d='M5.333 25.26l2.661 4.604h16.011l2.661-4.604zM32 16l-2.683 4.651h-17.031l17.031-9.301zM0 16l2.683-4.651h17.031l-17.031 9.301zM5.333 6.74l2.661-4.604h16.011l2.661 4.604z'/>"];
